module.exports = __webpack_public_path__ + "static/media/29BDOS8.7e4ca541.jpg";